import { LoadingButton } from '@mui/lab';
import { Box, Card } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import { firestore } from '../../../../../contexts/FirebaseContext';
import DescuentoForm from './DescuentoForm';

function ListaDescuentoPaq({ dataUser }) {
  const [listaPaqueteria, setListaPaqueteria] = useState([]);
  const [descuentosDoc, setDescuentosDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuthUsers();

  const hablitarDescuentoDoc = async () => {
    setLoading(true);
    await firestore.collection('desc_porPaqueteria').doc(dataUser.id).set({
      id: dataUser.id,
      userId: dataUser.id,
      creatorUserId: currentUser.id,
      listPaqDesc: [],
      status: 'active',
      createdAt: new Date()
    });

    setLoading(false);
  };

  useEffect(() => {
    function getData() {
      firestore.collection('proveedores_paq').onSnapshot((query) => {
        const dataProv = query.docs.map((item) => ({ id: item.id, ...item.data() }));

        let arrPaqs = [];
        // eslint-disable-next-line array-callback-return
        dataProv.map((item) => {
          arrPaqs = [...arrPaqs, ...item.rate_providers];
        });

        const uniqueArray = arrPaqs.filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id));

        console.log(arrPaqs, uniqueArray);
        setListaPaqueteria(uniqueArray);
      });
    }

    if (descuentosDoc) {
      getData();
    }
  }, [descuentosDoc]);

  useEffect(() => {
    function getDataDesc() {
      firestore
        .collection('desc_porPaqueteria')
        .doc(dataUser.id)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setDescuentosDoc({ id: doc.id, ...doc.data() });
          }
        });
    }

    getDataDesc();
  }, [dataUser.id]);

  return (
    <>
      {descuentosDoc && (
        <Box>
          {listaPaqueteria.map((item) => (
            <DescuentoForm key={item.id} dataItem={item} dataUser={dataUser} descuentosDoc={descuentosDoc} />
          ))}
        </Box>
      )}

      {!descuentosDoc && (
        <Card sx={{ padding: '15px', display: 'flex', justifyContent: 'center' }}>
          <LoadingButton onClick={hablitarDescuentoDoc} variant="contained">
            Habilitar descuento por paqueteria
          </LoadingButton>
        </Card>
      )}
    </>
  );
}

export default ListaDescuentoPaq;
